import {debounce, safeRedirect} from "@/helpers";

export default {
    computed: {
        debounceWebCamRedirect() {
            return debounce(() => {
                this.$store.dispatch('profile/getWebCamUrl')
                    .then(res => {
                        safeRedirect(res.data.url)
                    }, res => {
                        this.$router.push({name: 'home'})
                    })
            }, 400)
        }
    }
}
